import assets_personal_1_jpg from 'assets/personal/1.jpg'
import assets_personal_2_jpg from 'assets/personal/2.jpg'
import assets_personal_3_jpg from 'assets/personal/3.jpg'
import assets_personal_4_jpg from 'assets/personal/4.jpg'
import assets_personal_5_jpg from 'assets/personal/5.jpg'

export const content = [
    {
        id: 1,
        name: 'Карелова Галина Николаевна',
        photo: assets_personal_1_jpg,
        position_site: 'Координатор федерального партийного проекта «Старшее поколение», Сопредседатель общественного совета федерального партийного проекта «Женское движение Единой России», заместитель Председателя Совета Федерации Федерального Собрания Российской Федерации ',
    },
    {
        id: 2,
        name: 'Лантратова Дарья Сергеевна',
        photo: assets_personal_2_jpg,
        position_site: 'Заместитель Секретаря Генерального совета Партии, Сопредседатель общественного совета федерального партийного проекта «Женское движение Единой России», сенатор Российской Федерации',
    },
    {
        id: 3,
        name: 'Полуянова Наталия Владимировна',
        photo: assets_personal_3_jpg,
        position_site: 'Координатор федерального партийного проекта "Женское движение Единой России", депутат Государственной Думы Федерального Собрания Российской Федерации',
    },
    {
        id: 4,
        name: 'Оргеева Марина Эдуардовна',
        photo: assets_personal_4_jpg,
        position_site: 'Депутат Государственной Думы РФ, заместитель председателя Комитета по труду, социальной политике и делам ветеранов, статс-секретарь общественного совета проекта «Женское движение Единой России»',
    },
    {
        id: 5,
        name: 'Власова Вероника Валериевна',
        photo: assets_personal_5_jpg,
        position_site: 'Депутат Государственной Думы РФ, кандидат медицинских наук, Руководитель проекта «Женское здоровье»',
    },

]
